import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import api from '../../utils/api';

// Thunk to fetch top topcategories
export const getTopCategoriesThunk = createAsyncThunk(
  'topcategories/getTopCategories',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.appearences(); 
      
      return response.data?.data;
    } catch (error) {
      console.log(error);
      
    }
  }
);

// Slice for categories
const topcategoriesSlice = createSlice({
  name: 'topcategories',
  initialState: {
    topCategories: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTopCategoriesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTopCategoriesThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.topCategories = action.payload;
      })
      .addCase(getTopCategoriesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default topcategoriesSlice.reducer;

